export default __webpack_public_path__ + "static/media/LO12.a09f1272.mp3";